/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartpackagelabel4Inputs */

const en_eventaistartpackagelabel4 = /** @type {(inputs: Eventaistartpackagelabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let Pulsify do everything`)
};

const de_eventaistartpackagelabel4 = /** @type {(inputs: Eventaistartpackagelabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles erledigen lassen`)
};

/**
* | output |
* | --- |
* | "Let Pulsify do everything" |
*
* @param {Eventaistartpackagelabel4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartpackagelabel4 = /** @type {((inputs?: Eventaistartpackagelabel4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartpackagelabel4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartpackagelabel4(inputs)
	return de_eventaistartpackagelabel4(inputs)
});
export { eventaistartpackagelabel4 as "eventAiStartPackageLabel" }